var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row"data-bind="visibleAnimated: Module() === \'Error\'"style="display:none"> <div class="col-md-12"> <p>Непредвиденная ошибка во время отправки заявки. Пожалуйста, попробуйте позднее.</p> </div> </div>';
}
return __p;
};
